export const SALES_OPERATIONS_KEYS = {
	QUERY: {
		SALES_PERFORMANCE: "getSalesPerformance",
		SALES_LOG_ANALYTICS: "getSalesAnalytics",
		SALES_LOG_SALES: "getSalesLogSales",
		SO_ALL_COMMISSION_CYCLES: "getAllSalesOperationCommissionCycles",
	},
	MUTATION: {
		// …
	},
	SUBSCRIPTION: {
		SALES_PERFORMANCE: "salesPerformance",
		SALES_LOG_ANALYTICS: "onCalculateSalesLogAnalytics",
		SALES_LOG_SALES: "salesLogSales",
	},
} as const;

// literal union types…
export type OperationType = keyof typeof SALES_OPERATIONS_KEYS; // "QUERY"|"MUTATION"|"SUBSCRIPTION"
export type SectionKey<T extends OperationType> = keyof (typeof SALES_OPERATIONS_KEYS)[T];
export type OperationName<T extends OperationType, K extends SectionKey<T>> = (typeof SALES_OPERATIONS_KEYS)[T][K];

export function getSalesOperationName<T extends OperationType, K extends SectionKey<T>>(type: T, key: K): OperationName<T, K> {
	return SALES_OPERATIONS_KEYS[type][key];
}

export const salesOperationQueryValues = Object.values(SALES_OPERATIONS_KEYS.QUERY) as OperationName<"QUERY", SectionKey<"QUERY">>[];

export const salesOperationSubscriptionValues = Object.values(SALES_OPERATIONS_KEYS.SUBSCRIPTION) as OperationName<
	"SUBSCRIPTION",
	SectionKey<"SUBSCRIPTION">
>[];
